"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortCriteriaResolver_1 = require("../../sortCriteria/SortCriteriaResolver");
var SortCriteriaPrebind = (function () {
    function SortCriteriaPrebind() {
        this.name = "sortCriteriaResolver";
    }
    SortCriteriaPrebind.prototype.getPrebind = function (args) {
        var criteriaResolver = new SortCriteriaResolver_1.SortCriteriaResolver(args.fieldsHandler);
        return function (sortCriteriaRawValue, element) {
            var sortCriteria = JSON.parse(sortCriteriaRawValue);
            if (Object.keys(sortCriteria).length === 0) {
                return null;
            }
            var sortType = (sortCriteria.type || "relevancy").toLowerCase();
            var sortDirection = (sortCriteria.direction || "ascending").toLowerCase();
            var toggleDirection = (element.dataset["scEnableDirectionToggle"] || "false").toLowerCase() === "true";
            if (sortType === "relevancy") {
                return criteriaResolver.resolveRelevancyCriteria();
            }
            else if (sortType === "date") {
                return criteriaResolver.resolveDateCriteria(sortDirection, toggleDirection);
            }
            else {
                var sortField = sortCriteria.field;
                return criteriaResolver.resolveFieldCriteria(sortField, sortDirection, toggleDirection);
            }
        };
    };
    return SortCriteriaPrebind;
}());
exports.SortCriteriaPrebind = SortCriteriaPrebind;



//////////////////
// WEBPACK FOOTER
// ./src/resolvers/prebinding/prebindHelpers/SortCriteria.ts
// module id = 43
// module chunks = 13 14